export const GET = {
  REQUEST: 'ApprovalSummary/GET/Request',
  SUCCESS: 'ApprovalSummary/GET/Success',
  FAILURE: 'ApprovalSummary/GET/Failure'
};

export const APPROVE = {
  REQUEST: 'ApprovalSummary/APPROVE/Request',
  SUCCESS: 'ApprovalSummary/APPROVE/Success',
  FAILURE: 'ApprovalSummary/APPROVE/Failure'
};

export const CANCEL_APPROVAL = {
  REQUEST: 'ApprovalSummary/CANCEL_APPROVAL/Request',
  SUCCESS: 'ApprovalSummary/CANCEL_APPROVAL/Success',
  FAILURE: 'ApprovalSummary/CANCEL_APPROVAL/Failure'
};

export const CLEAR_APPROVAL_SUMMARY = {
  REQUEST: 'ApprovalSummary/CLEAR_APPROVAL_SUMMARY/Request',
  SUCCESS: 'ApprovalSummary/CLEAR_APPROVAL_SUMMARY/Success',
  FAILURE: 'ApprovalSummary/CLEAR_APPROVAL_SUMMARY/Failure'
};
